
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    class AddBaseCost {
        warehouseInfoId: number;
        beginTime?: Date;
        endTime?: Date;
        isEffective: boolean;
        baseCost: number;
        baseSkuNums: number;
        exceedBaseSkuNums: number;
        exceedSkuCost: number;
        maxSkuCost?: number;
        sackPrice: number;
        orderType: number;
    }
    @Component
    export default class CreateBaseCostModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        freight: AddBaseCost = new AddBaseCost();
        selectDate: string = "";
        selectDates: string = "";
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        cargoCategoryType = Enums.CargoCategoryType;
        siteType = Enums.SiteSType;
        wareHouseOrderType = Enums.WarehouseOrderType;
        addLoding = false;
        amountTotal: string = '';;
        created() {
            this.getCity();
        }
        signFor() {
            this.save();
        }
        save() {
            (this.$refs.freightCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'basecostsetting/Add',
                        data: this.freight
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.freightCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }

        changeNumber1() {
     
                let str = '' + this.freight.baseCost;
                if (str.indexOf('.') != -1) {
                    let arr = str.split('');
                    arr.splice(arr.length - 1);
                    let str2 = arr.join('');
                    this.freight.baseCost = +str2;
                }
            }
   
    changeNumber2()
    {
        let str = '' + this.freight.exceedSkuCost;
        if (str.indexOf('.') != -1) {
            let arr = str.split('');
            arr.splice(arr.length - 1);
            let str2 = arr.join('');
            this.freight.exceedSkuCost = +str2;
        }
    }
           
    changeNumber3()
    {
        let str = '' + this.freight.maxSkuCost;
        if (str.indexOf('.') != -1) {
            let arr = str.split('');
            arr.splice(arr.length - 1);
            let str2 = arr.join('');
            this.freight.maxSkuCost = +str2;
        }
    }
        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.freight.warehouseInfoId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }
        cancel() {
            (this.$refs.freightCreateForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        freightRule = {

            warehouseId: [
                { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
            ],
            sackPrice: [
                { required: true, message: '麻布袋单价不能为空（按积分计算）', trigger: 'blur' }
            ],
            baseCost: [
                { required: true, message: '基本费用不能为空（按积分计算）', trigger: 'blur' }
            ],
            baseSkuNums: [
                { required: true, message: '基本SKU数量不能为空(单位为个)', trigger: 'blur' }
            ],
            exceedBaseSkuNums: [
                { required: true, message: '超过基本SKU数量不能为空(单位为个)', trigger: 'blur' }
            ],
            exceedSkuCost: [
                { required: true, message: '超过SKU费用不能为空（按积分计算）', trigger: 'blur' }
            ],
        };

    }
